import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd3c113e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  style: {"max-width":"800px"}
}
const _hoisted_3 = { class: "modal-content border-0 shadow-lg rounded-lg" }
const _hoisted_4 = { class: "modal-header border-0 py-3" }
const _hoisted_5 = { class: "modal-body p-4" }
const _hoisted_6 = { class: "progress-steps mb-4" }
const _hoisted_7 = { class: "step-container d-flex justify-content-between align-items-center position-relative" }
const _hoisted_8 = {
  key: 0,
  class: "bi bi-check-lg"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "connecting-line position-absolute" }, null, -1))
const _hoisted_11 = {
  class: "step-content",
  style: {"min-height":"400px","max-height":"400px","overflow-y":"auto"}
}
const _hoisted_12 = {
  key: 0,
  class: "fade-in"
}
const _hoisted_13 = {
  key: 0,
  class: "url-input-container"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, "Add a new job application"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Enter a job posting URL to auto-fill details or enter them manually")
], -1))
const _hoisted_15 = {
  key: 0,
  class: "url-input-group mb-4"
}
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-download me-2" }, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_21 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Unable to load job details from URL. Please try again or enter details manually.", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "text-center mt-4"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse mb-3" }, null, -1))
const _hoisted_26 = { class: "text-muted mb-0" }
const _hoisted_27 = {
  key: 2,
  class: "text-center"
}
const _hoisted_28 = {
  key: 1,
  class: "manual-entry-form"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "h5 mb-0" }, "Job Details", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-link-45deg me-1" }, null, -1))
const _hoisted_31 = { class: "row g-4" }
const _hoisted_32 = { class: "col-8" }
const _hoisted_33 = { class: "form-floating" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "roleTitle" }, "Role Title", -1))
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = { class: "form-floating" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "postedDate" }, "Date Posted", -1))
const _hoisted_38 = { class: "col-md-2" }
const _hoisted_39 = { class: "form-floating" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "salaryCurrency" }, "Currency", -1))
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "form-floating" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "salaryMin" }, "Minimum Salary", -1))
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "form-floating" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "salaryMax" }, "Maximum Salary", -1))
const _hoisted_47 = { class: "col-md-2" }
const _hoisted_48 = { class: "form-floating" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "salaryInterval" }, "Interval", -1))
const _hoisted_50 = { class: "col-12" }
const _hoisted_51 = { class: "form-floating" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "jobDescription" }, "Job Description", -1))
const _hoisted_53 = {
  key: 1,
  class: "fade-in"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "h5 mb-4" }, "Company & Role Details", -1))
const _hoisted_55 = { class: "row g-4" }
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "form-floating" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "companyName" }, "Company Name", -1))
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "form-floating" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "location" }, "Location", -1))
const _hoisted_62 = { class: "col-12" }
const _hoisted_63 = { class: "form-floating" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "What does the company do? What's their mission?", -1))
const _hoisted_65 = { class: "col-12" }
const _hoisted_66 = { class: "form-floating" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Why are you interested in this role? What makes you a good fit?", -1))
const _hoisted_68 = {
  key: 2,
  class: "fade-in"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold mb-3" }, "Review Your Application", -1))
const _hoisted_70 = { class: "review-container" }
const _hoisted_71 = { class: "review-card mb-3" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "review-card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Role Details")
], -1))
const _hoisted_73 = { class: "review-card-body py-2" }
const _hoisted_74 = { class: "row g-2" }
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "review-item" }
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "review-label me-2" }, "Role Title:", -1))
const _hoisted_79 = { class: "review-value" }
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "review-item" }
const _hoisted_82 = { class: "d-flex align-items-center" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "review-label me-2" }, "Company:", -1))
const _hoisted_84 = { class: "review-value" }
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "review-item" }
const _hoisted_87 = { class: "d-flex align-items-center" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "review-label me-2" }, "Location:", -1))
const _hoisted_89 = { class: "review-value" }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { class: "review-item" }
const _hoisted_92 = { class: "d-flex align-items-center" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "review-label me-2" }, "Salary Range:", -1))
const _hoisted_94 = { class: "review-value" }
const _hoisted_95 = { class: "col-md-6" }
const _hoisted_96 = { class: "review-item" }
const _hoisted_97 = { class: "d-flex align-items-center" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "review-label me-2" }, "Date Posted:", -1))
const _hoisted_99 = { class: "review-value" }
const _hoisted_100 = { class: "review-card" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "review-card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Your Comments")
], -1))
const _hoisted_102 = { class: "review-card-body py-2" }
const _hoisted_103 = {
  class: "mb-0 small",
  style: {"white-space":"pre-line","max-height":"100px","overflow-y":"auto"}
}
const _hoisted_104 = { class: "modal-footer border-0 p-4" }
const _hoisted_105 = { class: "d-flex gap-3" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-2" }, null, -1))
const _hoisted_107 = ["disabled"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right ms-2" }, null, -1))
const _hoisted_109 = { class: "spinner-border spinner-border-sm" }

import CreateOrUpdateApplication from "@models/dtos/CreateOrUpdateApplication";
import { ref, onMounted } from "vue";
import router from "../router";
import { ApplicationApiService } from "@/services/ApplicationApiService";
import Modal from "@/components/Modal.vue";
import { toast } from "vue3-toastify";
import { ApplicationStatus } from "@models/SystemEnums";
import { WebscrapeApiService } from "@/services/WebscrapeApiService";
import Subscribe from "@/views/Subscribe.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateApplication',
  props: {
  show: {
    type: Boolean,
    default: false
  },
  isModal: {
    type: Boolean,
    default: false
  },
  resumeId: {
    type: String,
    default: ""
  }
},
  emits: ['close', 'application-created'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const route = useRoute();

const loading = ref(false);
const applicationPhase = ref(1);
const showDetails = ref(false);
const steps = ref(["Job Details", "Company & Role", "Review"]);
const showSubscribeModal = ref(false);
const application = ref<CreateOrUpdateApplication | any>({
  id: null,
  userId: "",
  companyName: "",
  roleTitle: "",
  jobDescription: "",
  companyDescription: "",
  roleComments: "",
  applicationStatus: ApplicationStatus.APPLIED,
  index: 0,
  isDeleted: false,
  location: "",
  postedDate: "",
  salaryCurrency: "$",
  salaryMin: "",
  salaryMax: "",
  salaryInterval: "P/A",
  sourcedFrom: "",
  jobUrl: "",
  isRemote: false,
});
const jobListingURL = ref("");
const errorModal = ref(null);
const showUrlLoadError = ref(false);
const currentLoadingMessage = ref("");
const loadingMessages = [
  "Loading...",
  "Downloading webpage...",
  "Parsing webpage content...",
  "Extracting job description...",
  "Extracting company name...",
  "Extracting location...",
  "Extracting salary details...",
  "Extracting date posted...",
  "Analyzing job requirements...",
  "Extracting benefits information...",
  "Importing data...",
  "Validating data integrity...",
  "Organizing extracted information...",
  "Matching data to fields...",
  "Cleaning up extracted text...",
  "Formatting output...",
  "Preparing final data...",
  "Almost done...",
  "Finalizing details...",
  "Ready to display!",
];

let loadingInterval: number | null = null;

const startLoadingMessages = () => {
  let index = 0;
  currentLoadingMessage.value = loadingMessages[0];

  loadingInterval = window.setInterval(() => {
    index = (index + 1) % loadingMessages.length;
    currentLoadingMessage.value = loadingMessages[index];
  }, 2500);
};

const stopLoadingMessages = () => {
  if (loadingInterval) {
    clearInterval(loadingInterval);
    loadingInterval = null;
  }
};

async function loadDetailsFromURL() {
  if (!jobListingURL.value) return;

  loading.value = true;
  startLoadingMessages();

  try {
    const result = await WebscrapeApiService.getApplicationDetailsFromUrl(jobListingURL.value);
    if (result.status == 200) {
      application.value.companyName = result?.data.companyName;
      application.value.companyDescription = result?.data.companyDescription;
      application.value.jobDescription = result?.data.jobDescription;
      application.value.roleTitle = result?.data.roleTitle;
      application.value.location = result?.data.location;
      // Convert MM/DD/YYYY to ISO format
      const postedDate = result?.data.postedDate;
      if (postedDate) {
        const [month, day, year] = postedDate.split("/");
        application.value.postedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      } else {
        application.value.postedDate = new Date().toISOString().split("T")[0];
      }
      application.value.salaryCurrency = result?.data.salaryCurrency || "$";
      application.value.salaryMin = result?.data.salaryMin;
      application.value.salaryMax = result?.data.salaryMax;
      application.value.salaryInterval = result?.data.salaryInterval || "P/A";
      application.value.sourcedFrom = result?.data.sourcedFrom;
      application.value.isRemote = result?.data.isRemote || false;
      application.value.jobUrl = result?.data.jobUrl;
      showDetails.value = true;
    }
  } catch (err: any) {
    showUrlLoadError.value = true;
    if (err.response.data.error == "Quota exceeded") {
      toast.error("Quota exceeded, please upgrade your account");
      loading.value = false;
      showSubscribeModal.value = true;
    }
  } finally {
    loading.value = false;
    stopLoadingMessages();
  }
}

// Add a function to format the date for display
function formatDisplayDate(dateString: string) {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

async function buttonClicked() {
  if (applicationPhase.value === 2) {
    applicationPhase.value++;
  } else if (applicationPhase.value === 3) {
    await createApplication();
  } else {
    applicationPhase.value++;
  }
}

async function createApplication() {
  try {
    loading.value = true;
    const result = await ApplicationApiService.createOrUpdateApplication(application.value);
    window.dispatchEvent(new CustomEvent("application-created"));
    
    // Emit the application-created event with the new application data
    emit('application-created', result.data.id.toString());
    
    // Check if we should return to AIResumeEditor (coming from Optimize tab)
    const returnToAIResume = route.query.returnToAIResume === "true";
    const resumeId = props.resumeId || route.query.resumeId as string;
    
    if (!props.isModal) {
      if (returnToAIResume && resumeId && result.data?.id) {
        // Navigate to AIResumeEditor with the new application and resume IDs
        await router.push({
          name: "AIResumeEditorWithResume",
          params: {
            applicationId: result.data.id.toString(),
            resumeId: resumeId
          }
        });
      } else {
        // Default navigation to application details
        await router.push("/application/" + (result.data?.id || ""));
      }
    } else {
      // If in modal mode, just close the modal after emitting the event
      closeModal();
    }
  } catch (err: any) {
    await handleApplicationCreationError(err);
  } finally {
    loading.value = false;
  }
}

function handleApplicationCreationError(err: any) {
  if (err.status != 200) {
    if (err.response.data.error == "Quota exceeded") {
      toast.error("Quota exceeded, please upgrade your account");
      loading.value = false;
      showSubscribeModal.value = true;
    } else {
      toast.error("There has been a problem creating this application");
      loading.value = false;
      errorModal.value.show();
    }
  }
}

function getStepLabel(step: number) {
  switch (step) {
    case 1:
      return "Job Details";
    case 2:
      return "Company & Role";
    case 3:
      return "Review";
    default:
      return "";
  }
}

function toggleManualEntry() {
  showDetails.value = !showDetails.value;
  showUrlLoadError.value = false;
}

function closeModal() {
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Modal, {
      title: "There's been an error!",
      ref_key: "errorModal",
      ref: errorModal
    }, {
      body: _withCtx(() => [
        _createTextVNode("There was an error processing this request. Please try again later!")
      ]),
      _: 1
    }, 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showSubscribeModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(Subscribe, {
              "is-modal": true,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (showSubscribeModal.value = false))
            }),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close position-absolute top-0 end-0 m-4",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showSubscribeModal.value = false)),
              style: {"z-index":"1050"}
            })
          ]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", {
      class: _normalizeClass(["modal fade", { 'show d-block': __props.isModal && __props.show }]),
      tabindex: "-1",
      style: {"background":"rgba(0, 0, 0, 0.5)"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (__props.isModal)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn-close",
                  onClick: closeModal
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "step d-flex flex-column align-items-center position-relative"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["step-circle d-flex align-items-center justify-content-center rounded-circle mb-2", { 
                      'active': applicationPhase.value >= index + 1,
                      'completed': applicationPhase.value > index + 1 
                    }])
                    }, [
                      (applicationPhase.value > index + 1)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(index + 1), 1))
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["step-label text-center", { 'active': applicationPhase.value >= index + 1 }])
                    }, _toDisplayString(step), 3)
                  ]))
                }), 128)),
                _hoisted_10,
                _createElementVNode("div", {
                  class: "connecting-line-progress position-absolute",
                  style: _normalizeStyle({ width: applicationPhase.value >= steps.value.length ? `${100}%` : `${((applicationPhase.value - 1) / (steps.value.length - 1)) * 100}%`, maxWidth: 'calc(100% - 120px)' })
                }, null, 4)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (applicationPhase.value == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (!showDetails.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _hoisted_14,
                          (!loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Job listing URL",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((jobListingURL).value = $event)),
                                    onKeyup: _withKeys(loadDetailsFromURL, ["enter"])
                                  }, null, 544), [
                                    [_vModelText, jobListingURL.value]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary",
                                    onClick: loadDetailsFromURL,
                                    disabled: loading.value
                                  }, [
                                    _hoisted_18,
                                    (!loading.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Load from URL"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_20))
                                  ], 8, _hoisted_17)
                                ]),
                                (showUrlLoadError.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("p", _hoisted_26, _toDisplayString(currentLoadingMessage.value), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (!loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-link text-muted",
                                  onClick: toggleManualEntry
                                }, " Enter details manually ")
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (showDetails.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-4" }, [
                            _hoisted_29,
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-link",
                              onClick: toggleManualEntry
                            }, [
                              _hoisted_30,
                              _createTextVNode(" Load from URL instead ")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((application.value.roleTitle) = $event)),
                                  class: "form-control rounded-3",
                                  id: "roleTitle",
                                  placeholder: "Role Title"
                                }, null, 512), [
                                  [_vModelText, application.value.roleTitle]
                                ]),
                                _hoisted_34
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "date",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((application.value.postedDate) = $event)),
                                  class: "form-control rounded-3",
                                  id: "postedDate",
                                  placeholder: "Date Posted"
                                }, null, 512), [
                                  [_vModelText, application.value.postedDate]
                                ]),
                                _hoisted_37
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((application.value.salaryCurrency) = $event)),
                                  class: "form-control rounded-3",
                                  id: "salaryCurrency",
                                  placeholder: "Currency"
                                }, null, 512), [
                                  [_vModelText, application.value.salaryCurrency]
                                ]),
                                _hoisted_40
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((application.value.salaryMin) = $event)),
                                  class: "form-control rounded-3",
                                  id: "salaryMin",
                                  placeholder: "Minimum Salary"
                                }, null, 512), [
                                  [_vModelText, application.value.salaryMin]
                                ]),
                                _hoisted_43
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((application.value.salaryMax) = $event)),
                                  class: "form-control rounded-3",
                                  id: "salaryMax",
                                  placeholder: "Maximum Salary"
                                }, null, 512), [
                                  [_vModelText, application.value.salaryMax]
                                ]),
                                _hoisted_46
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((application.value.salaryInterval) = $event)),
                                  class: "form-control rounded-3",
                                  placeholder: "Interval",
                                  id: "salaryInterval"
                                }, null, 512), [
                                  [_vModelText, application.value.salaryInterval]
                                ]),
                                _hoisted_49
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((application.value.jobDescription) = $event)),
                                  class: "form-control rounded-3",
                                  id: "jobDescription",
                                  placeholder: "Job Description",
                                  style: {"height":"150px"}
                                }, null, 512), [
                                  [_vModelText, application.value.jobDescription]
                                ]),
                                _hoisted_52
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (applicationPhase.value == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((application.value.companyName) = $event)),
                            class: "form-control rounded-3",
                            id: "companyName",
                            placeholder: "Company Name"
                          }, null, 512), [
                            [_vModelText, application.value.companyName]
                          ]),
                          _hoisted_58
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((application.value.location) = $event)),
                            class: "form-control rounded-3",
                            id: "location",
                            placeholder: "Location"
                          }, null, 512), [
                            [_vModelText, application.value.location]
                          ]),
                          _hoisted_61
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((application.value.companyDescription) = $event)),
                            class: "form-control rounded-3",
                            style: {"height":"115px"},
                            placeholder: "Company Description"
                          }, null, 512), [
                            [_vModelText, application.value.companyDescription]
                          ]),
                          _hoisted_64
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((application.value.roleComments) = $event)),
                            class: "form-control rounded-3",
                            style: {"height":"115px"},
                            placeholder: "Your Interest"
                          }, null, 512), [
                            [_vModelText, application.value.roleComments]
                          ]),
                          _hoisted_67
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (applicationPhase.value == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _hoisted_69,
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, [
                                  _hoisted_78,
                                  _createElementVNode("span", _hoisted_79, _toDisplayString(application.value.roleTitle), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                  _hoisted_83,
                                  _createElementVNode("span", _hoisted_84, _toDisplayString(application.value.companyName), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_85, [
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("div", _hoisted_87, [
                                  _hoisted_88,
                                  _createElementVNode("span", _hoisted_89, _toDisplayString(application.value.location), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("div", _hoisted_92, [
                                  _hoisted_93,
                                  _createElementVNode("span", _hoisted_94, _toDisplayString(application.value.salaryCurrency) + " " + _toDisplayString(application.value.salaryMin) + " - " + _toDisplayString(application.value.salaryMax) + " / " + _toDisplayString(application.value.salaryInterval), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _createElementVNode("div", _hoisted_97, [
                                  _hoisted_98,
                                  _createElementVNode("span", _hoisted_99, _toDisplayString(formatDisplayDate(application.value.postedDate)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("p", _hoisted_103, _toDisplayString(application.value.roleComments || "No comments added."), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              (applicationPhase.value > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-light flex-grow-1",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (applicationPhase.value--))
                  }, [
                    _hoisted_106,
                    _createTextVNode(" Back ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary flex-grow-1",
                disabled: loading.value,
                onClick: buttonClicked
              }, [
                _withDirectives(_createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(applicationPhase.value === 3 ? "Create Application" : "Continue") + " ", 1),
                  _hoisted_108
                ], 512), [
                  [_vShow, !loading.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_109, null, 512), [
                  [_vShow, loading.value]
                ])
              ], 8, _hoisted_107)
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})